import { useLayoutEffect, useRef, useState } from "react";

let ctx;
const textWidth = (t, px) => {
  ctx = ctx || document.createElement("canvas").getContext("2d");
  ctx.font = `${px}px Helvetica, Arial, sans-serif`;
  return ctx.measureText(t).width;
};

// Mirrors pdf_utils.stamp_fields single-line auto-fit so the editor preview matches the signed PDF.
export const FitPreviewText = ({ text, pageWidthPt, testId }) => {
  const ref = useRef(null);
  const [box, setBox] = useState(null);

  useLayoutEffect(() => {
    const el = ref.current?.parentElement;
    if (!el) return;
    const ro = new ResizeObserver(() => setBox({ w: el.offsetWidth, h: el.offsetHeight, bl: el.clientLeft, bt: el.clientTop, pw: el.offsetParent?.clientWidth || 0 }));
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  let style = { visibility: "hidden" };
  if (box && box.pw && pageWidthPt) {
    const s = box.pw / pageWidthPt;
    const wPt = box.w / s, hPt = box.h / s;
    const pad = Math.min(wPt * 0.06, 4) + 1;
    const avail = Math.max(wPt - 2 * pad, 1);
    let size = Math.max(Math.min(hPt * 0.72, 14), 5);
    const tw = textWidth(text, size);
    if (tw > avail) size = Math.max((size * avail) / tw, 3.5);
    const baseline = hPt / 2 + size * 0.35;
    style = {
      left: pad * s - box.bl,
      top: (baseline - size * 0.77) * s - box.bt,
      fontSize: size * s,
      lineHeight: 1,
      fontFamily: "Helvetica, Arial, sans-serif",
    };
  }
  return (
    <span ref={ref} data-testid={testId} className="absolute whitespace-nowrap text-black pointer-events-none" style={style}>
      {text}
    </span>
  );
};
